const VEHICLE_MODE_MAP = {
  bike: "bicycling",
  bicycle: "bicycling",
  bicicleta: "bicycling",
  cycle: "bicycling",
  drive: "driving",
  driving: "driving",
  car: "driving",
  carro: "driving",
  moto: "driving",
  motorcycle: "driving",
  truck: "driving",
  caminhao: "driving",
  caminhão: "driving",
  walk: "walking",
  walking: "walking",
  pedestrian: "walking",
  onfoot: "walking",
  foot: "walking",
};

export function normalizeVehicleType(vehicleType) {
  if (typeof vehicleType !== "string") return "";

  return vehicleType
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function getGoogleMapsTravelMode(vehicleType) {
  const normalized = normalizeVehicleType(vehicleType);
  return VEHICLE_MODE_MAP[normalized] || "driving";
}

export function appendTravelModeToGoogleMapsUrl(url, vehicleType) {
  if (!url) return url;

  try {
    const parsed = new URL(url);
    parsed.searchParams.set("travelmode", getGoogleMapsTravelMode(vehicleType));
    return parsed.toString();
  } catch {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}travelmode=${getGoogleMapsTravelMode(vehicleType)}`;
  }
}
